// extracted by mini-css-extract-plugin
export var addButton = "_ga-0";
export var border = "_ga-8";
export var check = "_ga-h";
export var danger = "_ga-6";
export var dropdownContainer = "_ga-1";
export var editModalBody = "_ga-j";
export var footerContainer = "_ga-i";
export var fullWidth = "_ga-a";
export var hide = "_ga-9";
export var icon = "_ga-3";
export var input = "_ga-7";
export var inputFlex = "_ga-b";
export var inputWrapper = "_ga-c";
export var manualFocus = "_ga-5";
export var optionButton = "_ga-4";
export var pillWrapper = "_ga-e";
export var pointer = "_ga-2";
export var showOverflow = "_ga-f";
export var tagsFlex = "_ga-d";
export var xButton = "_ga-g";